// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ActiveStatus } from './active-status';
import { KitDetail } from './kit-detail';
import { ProgramKit } from './program-kit';
import { SupplierAccount } from './supplier-account';
import { ActiveStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Kit extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  getStatusParents() {
    return [this.supplierAccount];
  }

  getStatusId() {
    return this.activeStatusId;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** String(250) */
  description!: string;
  /** String(60) */
  name!: string;
  /** Binary */
  rowVersion!: any;
  /** Guid FK supplierAccount */
  supplierAccountId!: string;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** Inv FK kitId */
  kitDetails!: KitDetail[];
  /** Inv FK kitId */
  programKits!: ProgramKit[];
  /** FK supplierAccountId */
  supplierAccount!: SupplierAccount;
}

